import { merchantFeesService } from "services";

import { merchantFeesConstants } from "./merchantFees.constants";


export const merchantFeesActions = {
	updateFees,
};

function updateFees({ merchantId, fees }) {
	return dispatch => {
		dispatch(request());
		return merchantFeesService
			.updateFees({
				merchantId,
				fees,
			})
			.then(
				res => {
					dispatch(success());
					return Promise.resolve(res);
				},
				error => {
					dispatch(failure(error));
					return Promise.reject(error);
				},
			);
	};

	function request() {
		return {
			type: merchantFeesConstants.EDIT_MERCHANT_FEES_REQUEST,
		};
	}

	function success() {
		return {
			type: merchantFeesConstants.EDIT_MERCHANT_FEES_SUCCESS,
		};
	}

	function failure(error) {
		return {
			type: merchantFeesConstants.EDIT_MERCHANT_FEES_SUCCESS,
			error,
		};
	}
}
